import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

export default {
  read: (rut) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getClienteByRut/' + rut,
      method: 'post'
    })
  }
}
